// File: src/components/HomeWorkHighlight.js

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { client } from "../lib/sanity";
import { Link } from "react-router-dom";

const query = `*[_type == "caseStudy"] | order(date desc)[0] {
  title,
  slug { current },
  summary,
  image { asset->{url} }
}`;

export default function HomeWorkHighlight() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    client.fetch(query).then(setItem);
  }, []);

  if (!item) return null;

  return (
    <Wrapper>
      <SectionHeading>Recent Work</SectionHeading>
      <Content to={`/work/${item.slug.current}`}>
        {item.image?.asset?.url && (
          <Cover src={item.image.asset.url} alt={item.title} />
        )}
        <Text>
          <h3>{item.title}</h3>
          <p>{item.summary}</p>
          <CTA>View Case Study →</CTA>
        </Text>
      </Content>
      <MoreLink to="/work" className="btn-outline">
        View All Work
      </MoreLink>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  padding: 3rem 1rem;
  background: #ffffff;
`;

const SectionHeading = styled.h3`
  font-size: 1.75rem;
  color: #1f2937;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 4px;
    width: 50px;
    background: #4f46e5;
    border-radius: 2px;
  }
`;

const Content = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-decoration: none;
  color: inherit;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const Cover = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  object-fit: cover;
  border-radius: 0.5rem;
`;

const Text = styled.div`
  flex: 1;

  h3 {
    font-size: 1.5rem;
    margin: 0;
  }

  p {
    color: #374151;
    margin: 0.75rem 0;
  }
`;

const CTA = styled.span`
  display: inline-block;
  color: #4f46e5;
  font-weight: 600;
`;

const MoreLink = styled(Link)`
  display: block;
  margin-top: 2rem;
  text-align: center;
  font-weight: 600;
`;
